<template>
    <div class="reports">
        <div class="page-header">
            <div class="left">
                <h2 class="page-title">
                <inertia-link :href="'/backoffice/reports'" class="name">
                    <v-icon color="#921E61" class="mb-1">mdi-arrow-left-circle</v-icon>
                    {{ $page.props.lang.back || "Reports" }}
                </inertia-link>
               / {{ $page.props.lang.members || "Members" }} 
                </h2>
            </div>
        </div>
        <div class="table-header">
            <div class="pickers">
                <div class="field-group">
                    <p class="custom-label">{{ $page.props.lang.fromDate || 'From date' }}</p>
                    <v-menu
                    ref="menu"
                    v-model="fromDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="fromDate | formatDate"
                            append-icon="mdi-menu-down" outlined dense hide-details readonly v-bind="attrs" v-on="on" @click:append="fromDatePicker = true"></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="fromDate" :max="toDate"
                        :first-day-of-week="1" no-title scrollable color="primary">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="fromDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn text color="primary" @click="fromDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <div class="field-group">
                    <p class="custom-label">{{ $page.props.lang.toDate || 'To date' }}</p>
                    <v-menu
                    ref="menu"
                    v-model="toDatePicker"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field :value="toDate | formatDate"
                            append-icon="mdi-menu-down" outlined dense hide-details readonly v-bind="attrs" v-on="on" @click:append="toDatePicker = true"></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="toDate" :min="fromDate"
                        :first-day-of-week="1" locale="en" no-title scrollable color="primary">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="toDatePicker = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn text color="primary" @click="toDatePicker = false">{{ $page.props.lang.ok || "Ok" }}</v-btn>
                        </v-date-picker>
                    </v-menu>
                </div>
                <v-btn @click="filterByDates" color="primary" height="38">{{ $page.props.lang.apply || 'Apply' }}</v-btn>
            </div>
            <!-- <div class="totals">
                <h4 class="total">{{ $page.props.lang.totalPayments || 'Total payments' }}: {{ Number(total_payments).toFixed(2) }} {{ $page.props.organization.settings.currency }}</h4>
                <h4 class="total">{{ $page.props.lang.totalCharges || 'Total charges' }}: {{ Number(total_charges).toFixed(2) }} {{ $page.props.organization.settings.currency }}</h4>
            </div> -->
        </div>
        <div class="export-btn">
            <v-tooltip bottom open-delay="400">
                <template v-slot:activator="{on, attrs}">
                    <v-btn @click="exportMembers" color="primary" fab x-small outlined v-bind="attrs" v-on="on">
                        <v-icon>mdi-file-excel-box</v-icon>
                    </v-btn>
                </template>
                <span>{{ $page.props.lang.export || 'Export' }}</span>
            </v-tooltip>
        </div>
        <div class="table-container with-avatar">
            <v-data-table
            :headers="membersHeaders"
            :items="members"
            :page.sync="tablePage"
            @page-count="tablePageCount = $event"
            item-key="item.id"
            mobile-breakpoint="0"
            hide-default-footer>
                <template v-slot:item.first_name="{ item }">
                    <div class="name-medium">
                        <inertia-link :href="'/backoffice/members/details/'+item.id +'/overview'" class="name">
                            <v-avatar size="40">
                                <img :src="item.profile_photo_url + '?w=80'" alt="">
                            </v-avatar>
                            {{ item.full_name }}
                        </inertia-link>
                    </div>
                </template>
                <template v-slot:item.payments="{ item }">
                    <p class="amount">
                        {{ Number(item.payments).toFixed(2) }} <span class="table-currency">{{ $page.props.organization.settings.currency }}</span>
                    </p>
                </template>
                <template v-slot:item.debt="{ item }">
                    <p class="amount">
                        {{ Number(item.debt).toFixed(2) }} <span class="table-currency">{{ $page.props.organization.settings.currency }}</span>
                    </p>
                </template>
            </v-data-table>
        </div>
        <v-pagination v-model="tablePage" :length="tablePageCount" class="front-paginate"></v-pagination>
    </div>
</template>


<script>
import AppLayout from '@/js/Layouts/AppLayout'
import moment from 'moment'

export default {
    metaInfo() {
        return {
            title:  this.$page.props.lang.title || "Members Report"
        }
    },
    layout: AppLayout,
    props: {
        members: Array,
        lang: Object,
        total_charges: Number,
        total_payments: Number,
        dateFrom: String,
        dateTo: String
    },
    data(){
        return {
            totalCharges: this.total_charges,
            totalPayments: this.total_payments,
            date: moment().format('YYYY-MM-DD'),
            fromDatePicker: false,
            fromDate: moment(this.dateFrom).format('YYYY-MM-DD'),
            toDatePicker: false,
            toDate: moment(this.dateTo).format('YYYY-MM-DD'),
            membersHeaders: [
                {text: this.lang.fullName || 'Full name', value: 'first_name', align: 'start'},
                // {text: this.lang.email || 'Email', value: 'email', sortable: false, align: 'start'},
                {text: this.lang.activeSubscriptions || 'Active subscriptions', value: 'active_subscriptions', sortable: false, align: 'center'},
                {text: this.lang.payments || 'Payments', value: 'payments', sortable: false, align: 'end'},
                {text: this.lang.charges || 'Debt', value: 'debt', sortable: false, align: 'end'},
            ],
            tablePageCount: 0,
            tablePage: 1
        }
    },
    methods: {
        filterByDates() {
            this.$inertia.visit(
                '/backoffice/reports/members?dateFrom=' + this.fromDate + '&dateTo=' + this.toDate, 
                {only:['members', 'total_charges', 'total_payments', 'dateFrom', 'dateTo']}
            )
        },
        exportMembers(){
             window.location.href = '/backoffice/reports/members/export?dateFrom=' + this.fromDate + '&dateTo=' + this.toDate,
                    {only:['members', 'total_charges', 'total_payments', 'dateFrom', 'dateTo']}
        }
    }
}

</script>